import { Box, Text } from '@chakra-ui/react'
import FirestoreUser, {
  RoleChange,
  roleTitles,
} from '../../../../types/FirestoreUser'
import { HistoryAccordion } from './HistoryAccordion'

interface Props {
  roleChangeHistory: FirestoreUser['roleChangeHistory']
}

export function RoleChangeHistory({ roleChangeHistory }: Props) {
  if (!roleChangeHistory || roleChangeHistory.length === 0) return null

  function sortByDateDesc(a: RoleChange, b: RoleChange) {
    return new Date(b.changedAt).getTime() - new Date(a.changedAt).getTime()
  }

  function renderRoleChange(change: RoleChange, idx: number) {
    return (
      <Box key={idx} p={2} bg='gray.50' borderRadius='md'>
        <Text fontSize='sm'>
          <b>{roleTitles[change.role]}</b> role {change.action} by{' '}
          {change.changedBy}
        </Text>
        <Text fontSize='xs' color='gray.600'>
          Date: {new Date(change.changedAt).toLocaleString()}
        </Text>
      </Box>
    )
  }

  return (
    <HistoryAccordion
      title='Role Change History'
      items={roleChangeHistory}
      renderItem={renderRoleChange}
      sortFn={sortByDateDesc}
      emptyMessage='No role changes recorded.'
    />
  )
}
